import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=085cab9b&scoped=true"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"
import style0 from "./Contacto.vue?vue&type=style&index=0&id=085cab9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085cab9b",
  null
  
)

export default component.exports